export class UpdateGcpSourceAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccount",
            "baseName": "serviceAccount",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateGcpSourceAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
